import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { Call } from './../../../../sharedTypes/call';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-call-list',
  templateUrl: './call-list.component.html',
  styleUrls: ['./call-list.component.scss'],
  standalone: false
})
export class CallListComponent implements OnInit, OnDestroy {
    userCallSubs: any = [];
    waitForTicketNoSub: Subscription = new Subscription();
    zeitSub: Subscription = new Subscription();

    constructor(
        public firebaseService: FirebaseService,
        public router: Router,
        public glo: GlobalService,
        public cdr: ChangeDetectorRef,
    ) {}

    ngOnDestroy(): void {
        this.userCallSubs.forEach((element: Subscription) => {
            element.unsubscribe();
        });
        if (this.waitForTicketNoSub) {
            this.waitForTicketNoSub.unsubscribe();
        }
        if (this.zeitSub) {
            this.zeitSub.unsubscribe();
        }
    }

    public schonAlt(startUnix: number) {
        if (Date.now() - startUnix > 1000 * 60 * 60) {
            return true;
        }
        return false;
    }

    userCalls: any = {};
    ngOnInit(): void {
        this.cdr.detectChanges();
        this.zeitSub = this.glo.zeit.subscribe((zeit) => {
            this.cdr.detectChanges();
        });
        this.glo.users.forEach((user) => {
            if (user.sipgateUserId) {
                this.userCallSubs.push(
                    this.firebaseService.getLastUserCall(user.sipgateUserId).subscribe((lastCalls) => {
                        if (lastCalls && lastCalls.length > 0) {
                            this.userCalls[user.sipgateUserId] = lastCalls[0];
                        } else {
                            this.userCalls[user.sipgateUserId] = null;
                        }
                        this.cdr.detectChanges();
                    }),
                );
            }
        });
    }

    async createTicket(call: Call) {
        if (call.ticketId) {
            this.openTicket(call.ticketId);
            return;
        }
        const res = await this.glo.confirm('Neues Ticket anlegen?').toPromise();
        if (!res) {
            return;
        }
        this.glo.startLoading('Lege Ticket an...');
        const werte = { callId: call.xcid, clientId: '', leadId: '' };

        if (call.clientId) {
            werte.clientId = call.clientId;
        } else {
            if (call.leadId) {
                werte.leadId = call.leadId;
            }
        }
        const neuesTicketId = await this.firebaseService.createNewTicket(werte);
        this.waitForTicketNoSub = this.firebaseService.getTicket(neuesTicketId).subscribe((ticket) => {
            if (ticket && ticket.ticketNo) {
                this.waitForTicketNoSub.unsubscribe();
                this.glo.endLoading();
                this.openTicket(ticket.ticketId);
            }
        });
    }

    openTicket(ticketId: string) {
        this.router.navigate(['/tickets/show/' + ticketId]);
    }

    startCall(number: string) {
        this.firebaseService.startCall(number);
    }
    setCallArchiv(call: Call) {
        this.firebaseService.setCallArchiv(call.xcid);
    }
}
